<template>
	<div class="container element-container login-parent">
		<Transition name="fade-up">
			<div class="title-container">
				<img class="logo" src="/images/buzztime.svg" alt="Buzztime">
			</div>
		</Transition>
		
		<!-- TODO: refactor to button to redirect to game room for login -->
		<Transition name="fade-up-delayed">
			<div class="login-container">
				<h4>Login</h4>
				<form @submit.prevent="handleLogin">
					
					<div class="input-row">
						<input
							ref="inputEl"
							v-model="email"
							id="email"
							placeholder="Email"
							type="email"
							required
							:disabled="isLoading"
							autofocus
						/>
	<!--					<label for="email">Email:</label>-->
					</div>
					
					<div class="input-row">
						<input
							v-model="password"
							id="password"
							placeholder="Password"
							type="password"
							required
							:disabled="isLoading"
						/>
	<!--					<label for="password">Password:</label>-->
					</div>
					
					<button type="submit" :disabled="isLoading">
						{{ isLoading ? 'Logging in...' : 'Login' }}
					</button>
				</form>
				<p v-if="errorMsg" class="error">{{ errorMsg }}</p>
			</div>
		</Transition>
		<Transition name="fade-up-delayed-long">
			<div class="footer-container">
				<p>
					Use Buzztime Remote to operate paired Buzztime TV displays.
					A valid Buzztime Game Network subscription and host account is required.
					Visit <a href="https://www.buzztime.com">buzztime.com</a> to learn more.
				</p>
			</div>
		</Transition>
	</div>
</template>

<script setup>
import {ref, computed, nextTick, onMounted} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useMainStore} from '../store/main'
import {doLogin} from "../utils/api.js";

const email = ref('')
const password = ref('')
const errorMsg = ref('')
const isLoading = ref(false)
const router = useRouter()
const route = useRoute()
const store = useMainStore()

async function handleLogin() {
	if (!email.value || !password.value) {
		errorMsg.value = 'Please enter both email and password'
		return
	}
	
	isLoading.value = true
	errorMsg.value = ''
	
	const result = await doLogin(email.value, password.value)
	console.log('Login result:', result)
	if (result.ok) {
		const user = result.data
		
		console.log('[LOGIN] Login successful, user data:', user)

		await store.login(user);

		const {pairing_code} = route.query
		await router.push({name: 'home', query: pairing_code ? {pairing_code} : {}})
	} else {
		errorMsg.value = result.error || 'Login failed. Please try again.'
	}
	
	isLoading.value = false
}

// Autofocus on email input
// const inputEl = ref(null)
// onMounted(async () => {
// 	await nextTick()
// 	inputEl.value?.focus()
// })
</script>

<style scoped>
.title-container {
	width: 100%;
	display: flex;
	/*flex: 1; !* take up available space *!*/
	justify-content: center;
	align-items: center;
	margin-bottom: var(--spacing-xl);
	margin-top: var(--spacing-xl);
}

.logo {
	/*height: 4.5rem;*/
	width: 50%;
}

.login-parent {
	justify-content: space-between;
	/*height: calc(100dvh);*/
	/*margin-top: -4rem;*/
}

.login-container {
	max-width: 400px;
	margin: var(--spacing-md) auto;
	/*margin-bottom: 33%;*/
	padding: var(--spacing-xl);
	padding-top: calc(var(--spacing-xl)/2);
	background-color: var(--color-popup-dark-2);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-lg);
}

.input-row {
	margin-top: var(--spacing-xl);
	position: relative;
}

label {
	display: block;
	color: var(--color-text);
	text-align: start;
	
	position: absolute;
	left: 1rem;
	bottom: 0.2rem;
	padding: var(--spacing-xs);
	transition: var(--transition-base);
	background: var(--color-popup);
}

input {
	font-size: var(--font-size-base);
	width: 100%;
	padding: var(--spacing-md);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-sm);
	background: var(--color-popup);
}

input:focus+label,
input:not(:placeholder-shown) + label {
	transform: translateY(-1.5rem);
	color: var(--color-primary);
}

input:placeholder-shown + label {
	transform: translateY(0);
}

input:focus {
	border-color: var(--color-primary);
}

button {
	width: 100%;
	margin-top: var(--spacing-xl);
	padding: var(--spacing-md);
	background-color: var(--color-primary);
	color: #fff;
	border: none;
}

.error {
	margin-top: var(--spacing-md);
	color: var(--color-error);
}

.dev-hint {
	margin-top: var(--spacing-md);
	color: var(--color-primary);
	font-size: 14px;
	text-align: center;
}

.footer-container p {
	/*position: absolute;*/
	/*bottom: 0;*/
	/*left: 0;*/
	margin-bottom: var(--spacing-xl);
	width: 100%;
	font-size: var(--font-size-xs);
	text-align: center;
	color: var(--color-text-secondary);
}

@media (max-width: 480px) {
	.logo {
		width: 85%;
	}
}
</style>